import { TmdxAvatar } from '@ds';

export const OCSSupply = ({
  type,
  name,
  description,
}: {
  type: 'device' | 'supply';
  name?: string;
  description?: string;
}) => {
  return (
    <div className="flex items-center gap-2 p-2 bg-base-70 rounded-xl">
      <TmdxAvatar type={type} size="lg" className="rounded-xl shrink-0" />
      <div className="truncate">
        <div className="text-m-m truncate">{name ?? ''}</div>
        <div className="text-s-r text-base-20 truncate">{description ?? ''}</div>
      </div>
    </div>
  );
};
